/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Connectors_Secret_MissingInputs */



/**
* | output |
* | --- |
* | "Declared by the package but not configured" |
*
* @param {Partner_Connectors_Secret_MissingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_connectors_secret_missing = /** @type {((inputs?: Partner_Connectors_Secret_MissingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Connectors_Secret_MissingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Vom Paket deklariert, aber nicht konfiguriert")
	return /** @type {LocalizedString} */ ("Declared by the package but not configured")
});